export const formatPercentage = (value: number, fractionDigits = 0): string => {
  if (isNaN(value)) return "-";
  return `${(value * 100).toFixed(fractionDigits)}%`;
};
